import type { MailboxInfo } from "owa-client-types";
import { getApplicationSettings } from "owa-application-settings";
import { isAccountFeatureEnabled } from "owa-feature-flags";
import { isOfflinePeopleDataViaPDVEnabled } from "./isOfflinePeopleDataViaPDVEnabled";
import { isPDVHeaderInfoAndCardTypeEnabled } from "./isPDVHeaderInfoAndCardTypeEnabled";

export function isOnePersonContextualEnhancementEnabled(viewerMailboxInfo: MailboxInfo): boolean {
    // We are intentionally not passing in MailboxInfo to below
    // flight checks because framework sync currently is
    // completely conditioned on the global settings mailbox account's
    // flights since they have some trouble at this time
    // to completely flight offline by account.
    return (getApplicationSettings("OnePersonView").enhancedContextualization &&
        ((isOfflinePeopleDataViaPDVEnabled(viewerMailboxInfo) && // For PDV and offline enabled users
            isPDVHeaderInfoAndCardTypeEnabled(viewerMailboxInfo)) ||
            // For online-only users
            isAccountFeatureEnabled("peo-one-person-view", viewerMailboxInfo)));
}
